import Icons from "@/src/components/Icons";
import { addCommas, digitsEnToFa } from "@persian-tools/persian-tools";
import emptImage from "../../assets/img/emptFood.jpg";

import classNames from "classnames";
interface foodProps {
  data: any;
  onClick: any;
}
function FoodItem({ data, onClick }: foodProps) {
  const classBadge = classNames(
    "p-3 border w-fit rounded-xl  border-gray-100-mmpz cursor-pointer",
    {
      "bg-warning": data.editState == "Pending",
    }
  );
  const classBox = classNames(
    "w-[140px] flex justify-between items-center border bg-gray-50-mmpz rounded-xl border-gray-100-mmpz",
    {
      "border-gray-100-mmpz": data.editState != "Pending",
      "border-warning": data.editState == "Pending",
    }
  );
  return (
    <div className="rounded-2xl shadow-mmpz  flex bg-white">
      <img
        src={
          data?.foodImage ?  data.foodImage : emptImage
        }
        alt=""
        className="rounded-r-xl w-[154px] h-[154px] border border-gray-100-mmpz"
      />
      <div className="rounded-l-xl shadow-mmpz w-full ps-2 py-2  border-gray-100-mmpz border-l border-b border-t flex flex-col gap-2 min-h-[154px] justify-between">
        <div className="item flex justify-between items-center pe-2 mb-1">
          <h4 className="font-bold w-3/4 text-sm">{data.foodName}</h4>
          <span className="bg-success py-1 px-5 rounded-2xl text-xs text-white min-w-[90px] text-center">
            {data.state == "Confirmed" ? "فعال" : "غیر فعال"}
          </span>
        </div>
        <div className="item flex mb-1">
          {data.type === "Entree" ? (
            <Icons name="food" size={24} className="me-2" />
          ) : data.type === "Side" ? (
            <Icons name="sideFood" size={18} className="me-2" />
          ) : (
            <Icons name="other" size={18} className="me-2" />
          )}
          <span className="text-gray-200-mmpz text-xs flex justify-between w-full pe-2 items-center">
            {data.type === "Entree"
              ? "غذای اصلی"
              : data.type === "Side"
              ? "کنار غذا"
              : "سایر"}
            <span className="text-gray-200-mmpz text-xs mb-1">
              تعداد سفارش {digitsEnToFa(data.orderCount)}
            </span>
          </span>
        </div>
        <div className="item flex justify-between items-center pe-2">
          <div className="flex flex-col">
            <span className="flex text-xs items-center gap-2 text-gray-200-mmpz">
              <Icons name="star" className="mb-1" />
              {data.star
                ? digitsEnToFa(data.star.toFixed(1))
                : digitsEnToFa("0")}
            </span>
          </div>
          <div className={classBox}>
            <div
              className={classBadge}
              onClick={() => {
                if (data.editState != "Pending") onClick(data);
              }}
            >
              {" "}
              {data.editState == "Pending" ? (
                <Icons name="loader" size={14} fill="none" stroke="#fff" />
              ) : (
                <Icons name="edit" size={14} />
              )}
            </div>
            <div className="text-sm items-center py-2 w-full flex justify-end gap-2 pe-2 font-bold">
              {digitsEnToFa(addCommas(data.price))}{" "}
              <span className="text-xs text-gray-100-mmpz font-light">
                تومان
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FoodItem;
